module.exports = __webpack_public_path__ + "img/Untitled-3.97bfa514.png";